/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";


const SlideTextIzquierda = ({textos}) => {
  const [index, setIndex] = useState(0);
  const colores = ["#F58020", "#FFBE43"];
  const color = colores[index % 2];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % textos.length);
    }, 5000); // cambia cada 5 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "1.5rem", // suficiente para fuente de 12px
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start", // alineación a la izquierda
      }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "flex-start", // contenido alineado a la izquierda
            alignItems: "center",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            fontSize: "12px",
            fontWeight: "bold",
            color: color
          }}
        >
          {textos[index]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default SlideTextIzquierda;
